import { Component, Input, OnInit } from '@angular/core';
import { CreativeDetail } from '../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-marketron-preroll-creative',
	templateUrl: './marketron-preroll-creative.component.html',
	styleUrls: ['./marketron-preroll-creative.component.css']
})
export class MarketronPrerollCreativeComponent implements OnInit {
	@Input() creative: CreativeDetail;
	@Input() youtubeviewspermission: boolean = false;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true,
		allowTitleHTML: true
	};

	constructor() {}

	ngOnInit() {}
}
